/*
 * Copyright (c) 2024 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain
 * proprietary information of OCLC, Inc. and shall not be disclosed in whole or in
 * any part to any third party or used by any person for any purpose, without written
 * consent of OCLC, Inc.  Duplication of any portion of these  materials shall include this notice.
 *
 */

import { styled } from '@mui/material/styles';
import { Link } from '@mui/material';

export const StyledSmallLink = styled(Link)(({ theme }) => ({
  ...theme.typography.body2,
}));
